module.exports = __webpack_public_path__ + "static/img/Luke-Davies-Uniacke.81dda47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Davies-Uniacke.jpg
// module id = rhpk
// module chunks = 0